document.querySelectorAll('.js-question').forEach(
	(jsQuestion) => { jsQuestion.addEventListener('click', (e) => {
		e.preventDefault()

		const button = e.currentTarget,
			question = button.closest('.faq__question')

		if (button.closest(".page--faq")) {
			if (question.classList.contains('active')) {
				question.classList.remove('active')
				button.setAttribute('aria-expanded', false)
			} else {
				question.parentElement.querySelector('.active')?.classList.remove('active');
				question.classList.add('active')
				button.setAttribute('aria-expanded', true)
			}
		}
		else {
			question.classList.toggle('active')
		}
	})
})
